import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import { FilterOptionResponse } from '../types'

const fetchFilterOptionEClaimStatus = async () => {
  const response = await httpClientPrivate.get<FilterOptionResponse[]>(
    `${config.restUrl}/v1/backoffice/e-claim/filter-option/e-claim-status`,
  )

  return response.data
}

const useFilterOptionEClaimStatus = () => {
  const queryKey = ['useFilterOptionEClaimStatus']
  const queryFn = async () => fetchFilterOptionEClaimStatus()
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchFilterOptionEClaimStatus, useFilterOptionEClaimStatus }
